(function(angular) {
    'use strict';

    angular.module('aprima-core-ui')
        .directive('apSpinner', function () {
            return {
                restrict: 'E',
                controller: '$ionicSpinner',
                link: function ($scope, $element, $attrs, ctrl) {
                    var spinnerName = ctrl.init();
                    var size = $attrs.size || '1';
                    $element.addClass('spinner spinner-' + spinnerName + ' spinner-' + size + 'x');
                }
            };
        });

    angular.module('aprima-core-ui')
        .controller('$ionicSpinner', [
            '$element',
            '$attrs',
            'SpinnerService',
            function ($element, $attrs, SpinnerService) {
                var spinnerName, spinnerHtml;

                this.init = function () {
                    var spinnerConfiguration = SpinnerService.getSpinner($attrs.icon);
                    spinnerName = spinnerConfiguration.name;
                    spinnerHtml = spinnerConfiguration.html;

                    // Specifically for animations to work,
                    // Android 4.3 and below requires the element to be
                    // added as an html string, rather than dynmically
                    // building up the svg element and appending it.
                    $element.html(spinnerHtml);

                    this.start();

                    return spinnerName;
                };

                this.start = function () {
                    SpinnerService.startSpinner($element[0], spinnerName);
                };

            }]);
})(window.angular);